import { Box, IconStyled } from '@bechtel/gds';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const listWidth = '288px';
export const smallScreenListWidth = '240px';
export const collapsedListWidth = '32px';

interface ListContainerStyledProps {
  isListCollapsed?: boolean;
}

export const ListContainerStyled = styled.div<ListContainerStyledProps>`
  transition-duration: 160ms;
  transition-timing-function: ease-in-out;
  transition-property: width;
  height: 100vh;
  width: ${listWidth};

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: ${smallScreenListWidth};
  }
  ${({ isListCollapsed }) =>
    isListCollapsed &&
    css`
      width: ${collapsedListWidth} !important;
    `}
`;

export const ReportListContainerStyled = styled.div<ListContainerStyledProps>`
  display: flex;
  flex-direction: column;
  visibility: ${({ isListCollapsed }) => (isListCollapsed ? 'hidden' : 'visible')};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grey[1000]};
  left: 0;
  position: absolute;
  top: 0;
  height: 100vh;
  width: ${listWidth};
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
  &::before {
    box-shadow: 14px 0 12px -8px rgba(0, 0, 0, 0.1);
    content: '';
    height: 100%;
    pointer-events: none;
    position: absolute;
    right: 0;
    left: calc(${listWidth} - 32px);
    width: 32px;
  }
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    width: ${smallScreenListWidth};
    &::before {
      left: calc(${smallScreenListWidth} - 32px);
    }
  }
`;

export const NavLinkStyled = styled(NavLink)`
  display: block;
  text-decoration: none;
  transition-timing-function: ease-in-out;
  transition-duration: 80ms;
  transition-property: background-color;
  &:active,
  &.active,
  &:hover {
    background-color: ${({ theme }) => theme.colors.blue[100]};
  }
`;

export const MenuItemStyled = styled(Box).attrs({ px: { sm: '500' }, py: { sm: '700' } })`
  ${({ theme }) => css`
    border-bottom: solid 0.5px #979797;
    font-size: ${theme.fontSizes[400]};
    font-family: ${theme.fontFamilies['graphik']};
    color: ${theme.colors.black};
  `}
`;
export const ReportListCollapsedStyled = styled(Box)<ListContainerStyledProps>`
  visibility: ${({ isListCollapsed }) => (!isListCollapsed ? 'hidden' : 'visible')};
  background-color: ${({ theme }) => theme.colors.grey[100]};
  height: 100%;
  width: 100%;
`;

export const ExpandCollapseBorderBoxStyled = styled(Box)<ListContainerStyledProps>`
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  z-index: 1; /* z-index needed to show the border all the way to the top*/
  transition-duration: 160ms;
  transition-timing-function: linear;
  transition-property: background-color;
  left: ${({ isListCollapsed }) => (!isListCollapsed ? listWidth : collapsedListWidth)};
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${({ isListCollapsed }) => (!isListCollapsed ? smallScreenListWidth : collapsedListWidth)};
  }
  ${({ theme }) => css`
    background-color: transparent;
    &:hover {
      background-color: ${theme.colors.blue[800]};
    }
  `};
`;

//TODO: Adding IconStyled caused this typescript error. Need to check alternative
export const ExpandCollapseBoxStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  cursor: pointer;
  position: absolute;
  top: 338px;
  left: -11px;
  ${({ theme }) => css`
    border-radius: ${theme.radii[900]};
    background-color: ${theme.colors.white};
    box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 6px 10px 0 rgb(0 0 0 / 14%);
    height: ${theme.spacings[600]};
    width: ${theme.spacings[600]};
    transition-duration: 160ms;
    transition-timing-function: ease-in-out;
    transition-property: color, background-color;
    &:hover {
      background-color: ${theme.colors.blue[800]};
      ${IconStyled} {
        color: ${theme.colors.white};
      }
    }
    ${ExpandCollapseBorderBoxStyled}:hover & {
      background-color: ${theme.colors.blue[800]};
      ${IconStyled} {
        color: ${theme.colors.white};
      }
    }
  `}
`;
export const ReportListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  ${({ theme }) =>
    css`
      border-top: solid 1px ${theme.colors.grey['300']};
      overflow-y: auto;
    `}
`;
